import React from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from "universal-cookie";
import LoadingOverlay from "react-loading-overlay";
import TextInput from "../../widgets/TextInput";
import addStudente from "../../services/addStudente";
import addUtente from "../../services/addUtente";
import getCorsi from "../../services/getCorsi";
import FixButton from "../../widgets/Button";
import SelectInput from "../../widgets/SelectInput";
import Utils from "../../utils/utils";
import DataNascitaInput from "../../widgets/DataNascitaInput";
import ImageUploader from "../../widgets/ImageUploader";

export default class AddStudente extends React.Component {
  constructor(props) {
    super(props);

    this.pageDiv = {
      border: "1px solid #cccccc",
      padding: 10,
    };

    this.section = this.props.section;
    if (this.section == undefined) {
      const pathname = props.location.pathname;
      this.section = pathname.substring(8, pathname.length);
    }

    this.pageName = props.pageName;
    if (this.pageName == undefined) {
      this.pageName = this.section;
    }

    this.selectRef = React.createRef();
    this.userslist = [];

    this.state = {
      testo: "",
      menuBackground: "#ffffff",
      menuItemColor: "#000000",
      fontSize: 50,
      fontBold: false,
      logoPicture: "",
      logoMargin: 0,
      titleColor: "#000000",
      titleSize: 18,
      isLoading: false,
      addElementVisible: false,
      nome: "",
      cognome: "",
      mail: "",
      citta: "",
      note: "",
      dataNascita: "",
      cittaNascita: "",
      telefono: "",
      corsi: [],
      badgeImage: null,
    };

    this.grid = 2;

    this.dataNascita = React.createRef();

    this.pageTitle = "Aggiungi studente";
    this.startDateRef = React.createRef();
    this.endDateRef = React.createRef();
  }

  async componentDidMount() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    this.corsi = await getCorsi(username, token);

    this.corsiArray = this.corsi
      .filter((corso) => {
        const dateEnd = new Date(corso.dateEnd);
        return dateEnd > today;
      })
      .map((corso) => ({
        value: corso.id,
        label: corso.name,
      }));

    this.setState({ corsiArray: this.corsiArray });
  }

  lockedSaveStudente = Utils.disallowConcurrency(this.save.bind(this));

  render() {
    function createData(username, name, surname) {
      return { username, name, surname };
    }

    var rows = [];
    this.userslist.length > 0 &&
      this.userslist.map((v, k) => {
        rows.push(createData(v.username, v.name, v.surname));
      });

    return (
      <div>
        <LoadingOverlay
          active={this.state.isLoading}
          styles={{
            content: (base) => ({
              position: "relative",
              width: "100%",
              top: "200px",
            }),
          }}
          spinner
          text={"Loading your content..."}
        >
          <PageTitle title={this.pageTitle} />
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "20px",
              alignItems: "start",
            }}
          >
            <div
              style={{ display: "flex", flexDirection: "column", gap: "20px" }}
            >
              <TextInput
                name={"Nome"}
                value={this.state.nome}
                onChange={(text) => {
                  this.setState({ nome: text });
                }}
              />
              <TextInput
                name={"Cognome"}
                value={this.state.cognome}
                onChange={(text) => {
                  this.setState({ cognome: text });
                }}
              />
              <TextInput
                name={"Città di nascita"}
                value={this.state.cittaNascita}
                onChange={(text) => {
                  this.setState({ cittaNascita: text });
                }}
              />
              <DataNascitaInput
                name={"Data di nascita"}
                value={this.state.dataNascita}
                onChange={(text) => {
                  this.setState({ dataNascita: text });
                }}
              />
              <TextInput
                name={"Telefono"}
                value={this.state.telefono}
                onChange={(text) => {
                  this.setState({ telefono: text });
                }}
              />
              <ImageUploader
                name="Badge Utente"
                value={this.state.badgeImage}
                onChange={(image) => {
                  this.setState({ badgeImage: image });
                }}
              />
            </div>

            <div
              style={{ display: "flex", flexDirection: "column", gap: "20px" }}
            >
              <SelectInput
                ref={this.selectRef}
                value={this.state.corsi}
                name="Corsi"
                hidable={false}
                options={this.state.corsiArray}
                isMulti={true}
                onChange={(option) => this.setState({ corsi: option })}
              />
              <TextInput
                name={"Città di residenza"}
                value={this.state.citta}
                onChange={(text) => {
                  this.setState({ citta: text });
                }}
              />
              <TextInput
                name={"Mail"}
                value={this.state.mail}
                onChange={(text) => {
                  this.setState({ mail: text });
                }}
              />
            </div>
          </div>

          {/* Note e bottone salva */}
          <div style={{ marginTop: "20px" }}>
            <textarea
              placeholder="Note studente"
              style={{
                resize: "none",
                width: "100%",
                height: 100,
                padding: 10,
                borderRadius: 5,
                marginBottom: 20,
              }}
              onChange={(e) => this.setState({ note: e.target.value })}
            />
            <FixButton
              title={"Salva"}
              callback={
                this.state.isLoading ? () => {} : this.lockedSaveStudente
              }
            />
          </div>
        </LoadingOverlay>
      </div>
    );
  }

  async save() {
    // Validazioni di formato (opzionali, solo se i campi sono compilati)
    if (
      this.state.telefono.trim() !== "" &&
      (this.state.telefono.length < 10 || this.state.telefono.length > 11)
    ) {
      alert("Il numero di telefono deve contenere 10-11 cifre.");
      return;
    }

    if (
      this.state.mail.trim() !== "" &&
      (!this.state.mail.includes("@") || !this.state.mail.includes("."))
    ) {
      alert("Inserisci un indirizzo email valido.");
      return;
    }

    // Se tutti i controlli sono passati, procedi con il salvataggio
    this.setState({ isLoading: true });
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });

    var strCorsi = "";
    this.state.corsi &&
      this.state.corsi.forEach((c) => {
        strCorsi += c.value + ";";
      });

    let ret = await addStudente(
      username,
      token,
      this.state.cognome,
      this.state.nome,
      strCorsi,
      this.state.mail,
      "", // indirizzo - rimosso dal form
      this.state.citta,
      "", // codiceFiscale - rimosso dal form
      this.state.telefono,
      "", // professione - rimosso dal form
      "", // documentoIdentita - rimosso dal form
      this.state.note,
      this.state.dataNascita,
      this.state.cittaNascita,
      this.state.badgeImage
    );

    var newUsername = await Utils.generateUsername(
      username,
      token,
      this.state.nome,
      this.state.cognome
    );
    var password = Utils.generatePassword();
    var asd = await addUtente(
      username,
      token,
      "",
      "",
      newUsername,
      password,
      1,
      ret.id
    );

    if (ret.result == "ok") {
      this.setState({ isLoading: false });
      window.location.href = "/#/app/studenti";
    } else {
      this.setState({ isLoading: false });
      alert(
        "Si è verificato un errore durante la creazione dello studente. Per favore, riprova."
      );
    }
  }
}
